import React from 'react';
import './HeroSection.css';
import profilePic from '../images/my_image.jpg';
import { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { useLanguage } from '../hooks/useLanguage';

const Hero = () => {
  const { t } = useLanguage();

  useEffect(() => {
    AOS.init({ duration: 800, once: true });
  }, []);

  return (
    <section className="hero" id="hero">
      <div className="hero-content">
        <img
          src={profilePic}
          alt={t.hero.name}
          data-aos="zoom-in"
          data-aos-delay="200"
          className="hero-image"
        />
        <div className="hero-text">
          <h1 className="hero-title">{t.hero.name}</h1>
          <h2 className="hero-subtitle">{t.hero.subtitle}</h2>
        </div>
      </div>
    </section>
  );
};

export default Hero;
